<template>
  <v-container fluid>
    <PageTitle title="Side Menus" />

    <ApiDataTable
      :can-insert="true"
      :can-update="true"
      :can-delete="true"
      data-api="sidemenus"
      :row-buttons="rowButtons"
      @row-button-click="rowButtonClick"
      :filters="[{ name: 'parentId', compare: '=', value: 0 }]"
    />

    <v-dialog v-model="dialog" scrollable width="800">
      <v-card>
        <v-card-title>Edit {{ editItem.title }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5">
          <ApiDataTable
            ref="sub_menus"
            :can-insert="true"
            :can-update="true"
            :can-delete="true"
            data-api="sidemenus"
            :filters="filters"
            :params="params"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ApiDataTable from "../ui/shared/ApiDataTable.vue";
import PageTitle from "../ui/shared/PageTitle.vue";

export default {
  name: "SideMenus",

  components: { ApiDataTable, PageTitle },

  computed: {
    rowButtons() {
      return [
        {
          text: "Edit Sub Menus",
          icon: "mdi-playlist-edit",
        },
      ];
    },
  },

  data() {
    return {
      editItem: {},
      dialog: false,
      filters: [
        {
          name: "parentId",
          compare: "=",
          value: 0,
        },
      ],
      params: { parentId: 0 },
    };
  },

  methods: {
    rowButtonClick({ item }) {
      this.editItem = item;
      this.filters[0].value = item.menuId;
      this.params.parentId = item.menuId;
      this.dialog = true;

      if (this.$refs.sub_menus) this.$refs.sub_menus.refresh(true);
    },
  },
};
</script>
